<div class="register-container" >
  <div *ngIf="toggleRegister" class="register" [class.register-right]="translate.currentLang === 'ar'"
       style="background-image: url('assets/images/login/boywithmob.png'),
    url('assets/images/login/girlwithkey.png');
    background-position: bottom left , bottom right;
    background-repeat: no-repeat,no-repeat;
    background-size: 350px , 350px;max-width: 1300px">
    <img style="cursor: pointer" [routerLink]="['/']" src="assets/images/newLogo.png">
    <h2>{{"REGISTER.REGISTER_TO_ACCOUNT" | translate}}</h2>
    <mat-horizontal-stepper style="background-color: transparent" #stepper [linear]="true">
      <mat-step [stepControl]="phoneInformation" [label]="'CUSTOMER.CREDENTIALS' | translate">
        <form style="margin: 20px 0" class="register-form" [formGroup]="phoneInformation" autocomplete="off">
          <div class="row">

            <div class="col-sm-12 field-text">


              <div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
                <div style="display: flex;align-items: center;justify-content: center;gap: 2px" role="alert">
                  <span class="f-s-12">
                    {{'CUSTOMER.REGISTRATION_INFO'|translate}}
                  </span>
<!--                  <mat-icon>warning</mat-icon>-->
                </div>
              </div>



            </div>
            <div class="col-sm-12 field" >
              <div class="row"  style="display: flex; align-items: center;">
                <div class="col-sm-9">
                  <mat-form-field class="w-100" style="padding: 0" appearance="outline">
                    <mat-label>{{"CUSTOMER.PHONE_NUMBER" | translate}}</mat-label>
                    <span matPrefix>{{countryReference?.value?.countryCallingCode}} &nbsp;</span>
                    <input [pattern]="countryReference?.value?.phoneRegex" type="tel" matInput formControlName="phoneNumber" (keypress)="keyPress($event)" required>
                  </mat-form-field>
                </div>

                <div class="col-sm-3" [ngStyle]="translate.currentLang === 'ar' ? { 'padding-right': '0' } : { 'padding-left': '0' }">
                  <mat-form-field appearance="outline" class="w-100" >
                    <mat-label> {{'CUSTOMER.COUNTRY' | translate}}</mat-label>
                    <mat-select #countryReference [value]="countries[0]"  name="country">
                      <mat-option *ngFor="let country of countries" [value]="country">
                        {{country.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>


              </div>
              <div *ngIf="phoneInformation.get('phoneNumber').errors?.required && phoneInformation.get('phoneNumber').touched">
                <p style="color: red;">{{"CUSTOMER.PHONE_NUMBER" | translate}} {{"COMMON.required" | translate}}</p>
              </div>
            </div>
            <div class="col-sm-12 field">
              <mat-form-field appearance="outline" class="w-100" color="primary">
                <mat-label>{{ "COMMON.PASSWORD" | translate }}</mat-label>
                <input  matInput formControlName="password"
                       [type]="showPasswordText ? 'password' : 'text'"
                >
                <i class="material-icons op-5" style="cursor: pointer;padding: 0 3px" matSuffix (click)="showPasswordText = !showPasswordText">
                  {{showPasswordText ? 'visibility' : 'visibility_off'}}
                </i>
              </mat-form-field>
              <div *ngIf="phoneInformation.get('password').errors?.pattern && phoneInformation.get('password').touched">
                <p style="color: red;">{{"COMMON.PASSWORD_COMPLEXTY"|translate}}</p>
              </div>
            </div>
            <div class="col-sm-12 field">
              <mat-form-field appearance="outline" class="w-100" color="primary">
                <mat-label>{{ "COMMON.CONFIRM_PASSWORD" | translate }}</mat-label>
                <input matInput formControlName="confirmPassword"
                       [type]="showConfirmPasswordText ? 'password' : 'text'">
                <i class="material-icons op-5" style="cursor: pointer;padding: 0 3px" matSuffix
                   (click)="showConfirmPasswordText = !showConfirmPasswordText">
                  {{showConfirmPasswordText ? 'visibility' : 'visibility_off'}}
                </i>
              </mat-form-field>
              <div *ngIf="phoneInformation.get('confirmPassword').errors?.pattern">
                <p style="color: red;">{{"COMMON.PASSWORD_COMPLEXTY"|translate}}</p>
              </div>
            </div>
            <div *ngIf="phoneInformation.value.password && phoneInformation.value.confirmPassword
            && phoneInformation.value.password != phoneInformation.value.confirmPassword">
              <p style="color: red;">{{'COMMON.PASSWORD_NOT_IDENTICAL'|translate}}</p>
            </div>
          </div>
          <div class="row" style="align-items: center;justify-content: space-between">
            <div class="login-text col-sm-7" >
              <div style="display: flex;justify-content: space-between;align-items: baseline">
                <p>{{ "LOGIN.HAVE_ACCOUNT" | translate }}</p>
                <div [routerLink]="['../login']">
                  <button
                    style="font-size: 13px;text-decoration: underline" mat-button type="button" color="primary">
                    <span>{{ "LOGIN.LOGIN" | translate }}</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-sm-5 row" style="justify-content: flex-end">
            <button mat-button  [disabled]="phoneInformation.invalid || phoneInformation.value.password != phoneInformation.value.confirmPassword"  (click)="checkPhoneNumber(stepper)">{{"CUSTOMER.NEXT" | translate}}</button>
            <mat-error *ngIf="msg">{{msg}}</mat-error></div>

          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="basicInformation" [label]="'CUSTOMER.basic_information' | translate">
        <form style="margin: 20px 0" class="register-form" [formGroup]="basicInformation">
          <div class="row">
            <div class=" col-sm-12 field">
              <mat-form-field appearance="outline" color="primary" class="w-100">
                <mat-label>{{"CUSTOMER.FULL_NAME" | translate}}</mat-label>
                <input (keydown)="checkSpace($event)" matInput formControlName="fullName" required>
                <mat-error *ngIf="hasError('fullName', 'required')">{{"CUSTOMER.FULL_NAME" | translate}}
                  {{"COMMON.required" | translate}} </mat-error>
                <div *ngIf="basicInformation.hasError('whitespace')">{{'COMMON.VALIDATIONS.NO_WHITESPACE'}}</div>
              </mat-form-field>
            </div>
            <div class=" col-sm-12 field">
              <mat-form-field appearance="outline" color="primary" class="w-100">
                <mat-label>{{"CUSTOMER.EMAIL" | translate}}</mat-label>
                <input matInput formControlName="email">
                <mat-error *ngIf="hasError('email', 'email')">{{"CUSTOMER.EMAIL" | translate}}
                  {{"COMMON.incorrect" | translate}} </mat-error>
              </mat-form-field>
            </div>
            <div class=" col-sm-12 field">
              <mat-form-field appearance="outline" color="primary" class="w-100">
                <mat-label>{{"CUSTOMER.VAT_NUMBER" | translate}}</mat-label>
                <input matInput formControlName="nationalId" onlyNumber>
              </mat-form-field>
            </div>

            <div class=" col-sm-12 field">
              <mat-form-field appearance="outline" color="primary" class="w-100">
                <mat-label>{{"CUSTOMER.customer'sـtrade" | translate}}</mat-label>
                <input (keydown)="checkSpace($event)" matInput formControlName="customerLegalEntityName" required>
                <mat-error
                  *ngIf="hasError('customerLegalEntityName', 'required')">{{"CUSTOMER.customer'sـtrade" | translate}}
                  {{"COMMON.required" | translate}} </mat-error>
                <div *ngIf="basicInformation.hasError('whitespace')">{{'COMMON.VALIDATIONS.NO_WHITESPACE'}}</div>
              </mat-form-field>
            </div>

            <div class=" col-sm-12 field">
              <mat-form-field appearance="outline" color="primary" class="w-100">
                <mat-label>{{"CUSTOMER.customer'sـcommercialـnumber" | translate}}</mat-label>
                <input matInput formControlName="customerLegalEntityNumber">
              </mat-form-field>
            </div>
          </div>
          <div style="display: flex;justify-content: space-between; padding: 10px">
            <button mat-button matStepperPrevious>{{"CUSTOMER.BACK" | translate}}</button>
            <button mat-button matStepperNext
                    [disabled]="basicInformation.invalid">{{"CUSTOMER.NEXT" | translate}}</button>
          </div>
        </form>

      </mat-step>
      <mat-step [stepControl]="thirdInformation" [label]="'CUSTOMER.ADDRESS' | translate">

        <form style="margin: 20px 0" class="register-form" [formGroup]="thirdInformation">
          <div class="row">
            <div class=" col-sm-12">
              <mat-form-field appearance="outline" color="primary" class="w-100">
                <mat-label>{{ "CUSTOMER.FORM.BRANCHES.FORM.COUNTRY" | translate }}
                </mat-label>
                <mat-select formControlName="country">
                  <mat-option *ngFor="let country of countries" [value]="country.id">
                    {{ country.name }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="hasInformationError('country', 'required')">{{ "CUSTOMER.FORM.BRANCHES.FORM.COUNTRY" | translate}}
                  {{"COMMON.required" | translate}} </mat-error>
              </mat-form-field>
            </div>

            <div *ngIf="validationThirdInformation.country.value > 0 && governorates.length > 0" class=" col-sm-12">
              <mat-form-field appearance="outline" color="primary" class="w-100">
                <mat-label>{{ "CUSTOMER.FORM.BRANCHES.FORM.GOVERNORATE" | translate }}
                </mat-label>
                <mat-select formControlName="governorate">
                  <mat-option *ngFor="let governorate of governorates" [value]="governorate.id">
                    {{ governorate.name }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="hasInformationError('governorate', 'required')">{{ "CUSTOMER.FORM.BRANCHES.FORM.GOVERNORATE" | translate}}
                  {{"COMMON.required" | translate}} </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="validationThirdInformation.governorate.value > 0 && cities.length > 0 && governorates.length > 0"
                 class="col-sm-12  col-sm-12">
              <mat-form-field appearance="outline" color="primary" class="w-100">
                <mat-label>{{ "CUSTOMER.FORM.BRANCHES.FORM.CITY" | translate }}
                </mat-label>
                <mat-select formControlName="city">
                  <mat-option *ngFor="let city of cities" [value]="city.id">
                    {{ city?.name }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="hasInformationError('city', 'required')">{{ "CUSTOMER.FORM.BRANCHES.FORM.CITY" | translate}}
                  {{"COMMON.required" | translate}} </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-12">
            <small style="color: red" *ngIf="validationThirdInformation.country.value &&
          governorates.length == 0 ||
          validationThirdInformation.country.value &&
           validationThirdInformation.governorate.value &&
            cities.length == 0">{{ "REGISTER.REGISTER_NO_DATA_MSG" | translate}}</small>
          </div>
          <div style="display: flex;justify-content: space-between;margin-top: 40px;">
            <button mat-button matStepperPrevious>{{"CUSTOMER.BACK" | translate}}</button>
            <button  mat-button (click)="createCustomerAccount()"
                     [disabled]="thirdInformation.invalid || basicInformation.invalid">{{"REGISTER.TITLE" |
              translate}}</button>
          </div>
        </form>
      </mat-step>
    </mat-horizontal-stepper>
    <div class="row options" style="justify-content: space-between">
      <button (click)="changeLanguage()" mat-mini-fab
              matTooltip="{{translate.currentLang === 'ar' ? 'change language to english' : 'تغيير إلي اللغة العربية'}}"
              style="background-color: #6a259a;" aria-label="Example icon button with a home icon">
        <mat-icon>translate</mat-icon>
      </button>
      <button [routerLink]="['/index']" mat-mini-fab style="background-color: #6a259a;"
              matTooltip="{{translate.currentLang === 'ar' ? 'الرئيسية' : 'Home'}}"
              aria-label="Example icon button with a home icon">
        <mat-icon>home</mat-icon>
      </button>
    </div>
  </div>
</div>

